import OneSignal from "react-onesignal";
const oneSignalAppId = process.env.REACT_APP_ONESIGNAL_APP_ID;

export const initOneSignal = async () => {
  console.log("Initializing OneSignal...");
  await OneSignal.init({
    appId: oneSignalAppId,
    allowLocalhostAsSecureOrigin: true,
    autoResubscribe: true,
    notifyButton: {
      enable: true
    }
  });
  console.log("OneSignal Initialized");

};
